import { CONTROLLER_CATALOG_ITEM_TYPES } from "../../../enums/controllerCatalogItemTypes";
import { Reference } from "../../shared/refs";

export type ControllerModelRef = Reference;

export interface ControllerModelObject {
  id?: string;
  label: string;
  manufacturer: Reference;
  faultList?: Reference;
  notes?: string | null;
}

export class ControllerModel {
  public id?: string;
  label: string;
  public manufacturer: Reference;
  public faultList?: Reference;
  public notes?: string | null;
  public controllerCatalogItemType: string = CONTROLLER_CATALOG_ITEM_TYPES.MODEL;

  constructor(controllerModel: ControllerModelObject) {
    this.id = controllerModel.id;
    this.label = controllerModel.label;
    this.manufacturer = controllerModel.manufacturer;
    this.faultList = controllerModel.faultList;
    this.notes = controllerModel.notes;
  }

  public set properties(controllerModel: ControllerModelObject) {
    this.label = controllerModel.label;
    this.faultList = controllerModel.faultList;
    this.notes = controllerModel.notes;
  }

  public get values() {
    const controllerModel: ControllerModelObject = {
      label: this.label,
      manufacturer: this.manufacturer,
      notes: this.notes,
    };

    delete controllerModel.manufacturer.label;

    if (this.faultList) {
      controllerModel.faultList = this.faultList;

      delete controllerModel.faultList.label;
    }
    return controllerModel;
  }
}
